import type { DevModeLifecycleHookEvent } from '@cli-types/next-adapter/generators.js'
export function lifecycleHookActionLabel(event: DevModeLifecycleHookEvent): string {
  return event.replace(/([A-Z])/g, ' $1').toLowerCase()
}
